import { submitOnEnter } from '../helpers/submitOnEnter'


const defaultParams = {
    guideFinderMakeSelector: '',
    guideFinderYearSelector: '',
    guideFinderModelSelector: '',
    guideFinderTrimSelector: '',
    guideFinderConnectionSelector: '',
    guideFinderInstallTypeSelector: '',
    guideFinderDeviceSelector: '',
    guideFinderResetSelector: '',
    guideFinderSelectSelector: '',
    guideFinderInputSearchSelector: '',
    guideFinderBtnSearchSelector: '',
    guideFinderGuideIdSelector: '',
    guideFinderProductIdSelector: ''
}

const defaultUrls = {
    yearsByMake: '',
    makesByYears: '',
    modelsByMakeYear: '',
    trimsByMakeModelYear: '',
    guides: ''
}

export default class GuideFinder {
    constructor(selector, params, urls) {
        this.selector = selector;
        this.params = $.extend({}, defaultParams, params)
        this.urls = $.extend({}, defaultUrls, urls)
        this.$window = $(window);
        this.makeid = null;
        this.year = null;
        this.trimid = null;
        //this.isSelectedVehicle = false;
    }

    //get value of make
    getMakeId() {
        return this.constructor.makeid;
    }

    //set value of make
    setMakeId(makeValue) {
        $(this.params.guideFinderMakeSelector + " option").removeAttr('selected');
        $(this.params.guideFinderMakeSelector + ' option[value="' + makeValue + '"]').attr("selected", true);
        return this.constructor.makeid = makeValue;
    }

    //get value of year
    getYear() {
        return this.constructor.year;
    }
    //set value of year
    setYear(yearValue) {
        $(this.params.guideFinderYearSelector + " option").removeAttr('selected');
        $(this.params.guideFinderYearSelector + ' option[value="' + yearValue + '"]').attr("selected", true);
        this.constructor.year = yearValue;
    }

    init() {
        $().ready(() => {

            //on init listen if make is changing 
            this.onChangeMake();
            //on init listen if year is changing 
            this.onChangeYear();
            //on init listen if model is changing 
            this.onChangeModel();
            //on init listen if other select is changing 
            this.onChangeOther();
            //on click on reset button run reset function
            $(this.params.guideFinderResetSelector).on('click', () => {
                this.resetAllSelect()
            })
            //on enter in search input trigger click event
            submitOnEnter(this.params.guideFinderBtnSearchSelector, this.params.guideFinderInputSearchSelector)
            //on click on search button get guide by number value from input 
            $(this.params.guideFinderBtnSearchSelector).on('click', () => {
                this.getGuideByNumber()
            })
        });
    }

    //listen if make is changing, if selected get the year
    onChangeMake() {
        $(this.params.guideFinderMakeSelector).on('change', () => {
            this.resetSelect(this.params.guideFinderModelSelector);
            this.disableSelect(this.params.guideFinderTrimSelector);
            this.disableSelect(this.params.guideFinderModelSelector);
            this.getYearsByMake(
                this.getSelectedOption(this.params.guideFinderMakeSelector),
                this.params.guideFinderYearSelector);
            this.getGuides(this.getSelectedOption(this.params.guideFinderMakeSelector))
        });
    }

    //listen if year is changing, if selected get the makes
    onChangeYear() {
        $(this.params.guideFinderYearSelector).on('change', () => {
            this.resetSelect(this.params.guideFinderModelSelector);
            this.resetSelect(this.params.guideFinderTrimSelector);
            this.disableSelect(this.params.guideFinderTrimSelector);
            this.getMakesByYear(
                this.getSelectedOption(this.params.guideFinderYearSelector),
                this.params.guideFinderMakeSelector);
            this.getGuides(
                this.getSelectedOption(this.params.guideFinderMakeSelector),
                this.getSelectedOption(this.params.guideFinderYearSelector))
        });
    }

    //listen if model is selected, if selected get the trims
    onChangeModel() {
        $(this.params.guideFinderModelSelector).on('change', () => {
            $(this.params.guideFinderTrimSelector).prop("disabled", false);
            this.getTrimsByMakeModelYear(
                this.getSelectedOption(this.params.guideFinderMakeSelector),
                this.getSelectedOption(this.params.guideFinderModelSelector),
                this.getSelectedOption(this.params.guideFinderYearSelector),
                this.params.guideFinderTrimSelector);
            this.getGuides(
                this.getSelectedOption(this.params.guideFinderMakeSelector),
                this.getSelectedOption(this.params.guideFinderYearSelector),
                this.getSelectedOption(this.params.guideFinderModelSelector))
        });
    }

    //listen if device is selected, if selected get the guides
    onChangeOther() {
        $(this.params.guideFinderTrimSelector + "," + this.params.guideFinderConnectionSelector + "," + this.params.guideFinderInstallTypeSelector + "," + this.params.guideFinderDeviceSelector).on('change', () => {
            this.getGuides(
                this.getSelectedOption(this.params.guideFinderMakeSelector),
                this.getSelectedOption(this.params.guideFinderYearSelector),
                this.getSelectedOption(this.params.guideFinderModelSelector),
                this.getSelectedOption(this.params.guideFinderTrimSelector),
                this.getSelectedOption(this.params.guideFinderConnectionSelector),
                this.getSelectedOption(this.params.guideFinderInstallTypeSelector),
                this.getSelectedOption(this.params.guideFinderDeviceSelector))
        });
    }

    //get the years in fact of the make selected
    getYearsByMake(selectedValue, elementToPopulate) {
        let self = this;
        $.ajax({
            url: self.urls.yearsByMake,
            method: "POST",
            data: { makeid: selectedValue },
        }).done(function (res) {
            $(elementToPopulate + " option").not(':first').remove();;
            for (let i = 0; i < res.length; i++) {
                $(elementToPopulate).append('<option value="' + res[i] + '">' + res[i] + '</option>');
            }
            cb();
        }).fail(function (xhr, textStatus, errorThrown) {
            console.log(textStatus)
        });

        this.setMakeId(selectedValue);
        function cb() {
            if (self.getYear()) {
                $(self.params.guideFinderYearSelector + ' option[value="' + self.getYear() + '"]').attr("selected", true)
            }
            if (self.getYear() && self.getMakeId()) {
                $(self.params.guideFinderModelSelector).prop("disabled", false);
                self.getModelsByMakeYear(self.getMakeId(), self.getYear(), self.params.guideFinderModelSelector)
            }
        }
    }

    //get the makes in fact of the year selected
    getMakesByYear(selectedValue, elementToPopulate) {
        let self = this;
        $.ajax({
            url: self.urls.makesByYears,
            method: "POST",
            data: { year: selectedValue },
        }).done(function (res) {
            $(elementToPopulate + " option").not(':first').remove();;
            for (let i = 0; i < res.length; i++) {
                $(elementToPopulate).append('<option value="' + res[i].makeid + '">' + res[i].name + '</option>');
            }
            cb();
        }).fail(function (xhr, textStatus, errorThrown) {
            console.log(textStatus)
        });

        this.setYear(selectedValue);

        function cb() {
            console.log('get make id:' + self.getMakeId())
            if (self.getMakeId() && self.getYear()) {
                $(self.params.guideFinderModelSelector).prop("disabled", false);
                self.getModelsByMakeYear(self.getMakeId(), self.getYear(), self.params.guideFinderModelSelector)
            }
            $(elementToPopulate + ' option[value="' + self.getMakeId() + '"]').attr("selected", true)
        }
    }

    //get models in fact of the year and the make selected
    getModelsByMakeYear(selectedMake, selectedYear, elementToPopulate) {
        let self = this;
        $.ajax({
            url: self.urls.modelsByMakeYear,
            method: "POST",
            data: { makeid: selectedMake, year: selectedYear },
        }).done(function (res) {
            $(elementToPopulate + " option").not(':first').remove();;
            for (let i = 0; i < res.length; i++) {
                $(elementToPopulate).append('<option value="' + res[i].modelid + '">' + res[i].name + '</option>');
            }
        }).fail(function (xhr, textStatus, errorThrown) {
            console.log(textStatus)
        });
    }

    //get trims in fact of the make, the year and the model selected
    getTrimsByMakeModelYear(selectedMake, selectedModel, selectedYear, elementToPopulate) {
        let self = this;
        $.ajax({
            url: self.urls.trimsByMakeModelYear,
            method: "POST",
            data: { makeid: selectedMake, modelid: selectedModel, year: selectedYear },
        }).done(function (res) {
            $(elementToPopulate + " option").not(':first').remove();
            for (let i = 0; i < res.length; i++) {
                $(elementToPopulate).append('<option value="' + res[i].vehicleid + '">' + res[i].trim_en + '</option>');
            }
        }).fail(function (xhr, textStatus, errorThrown) {
            console.log(textStatus)
        });
    }

    //disable the select
    disableSelect(selector) {
        $(selector).prop("disabled", true);
    }

    //reset the select
    resetSelect(selector) {
        $(selector + " option").removeAttr('selected');
        $(selector).val('');

    }

    //reset all the select
    resetAllSelect() {
        $(this.params.guideFinderSelectSelector + " option").removeAttr('selected');
        $(this.params.guideFinderSelectSelector).val('');
        $(this.params.guideFinderInputSearchSelector).val('');
        $(this.params.guideFinderConnectionSelector).val('All Connections');
        this.getAllGuides();
    }

    //return the value of the selected option in the DOM
    getSelectedOption(selector) {
        return $(selector).find(':selected').val();
    }

    //ajax for request the list of guides with selected param
    getGuides(makeid, ...option) {
        let self = this;
        let yearid = option[0]
        let modelid = option[1]
        let vehicleid = option[2]
        let connection = option[3]
        let install = option[4]
        let accessorytype = option[5]
        let productid = document.querySelector(this.params.guideFinderProductIdTag).getAttribute(this.params.guideFinderProductIdSelector)
        $.ajax({
            url: self.urls.guides,
            method: "POST",
            data: {
                productid: productid,
                makeid: makeid,
                yearid: yearid,
                modelid: modelid,
                vehicleid: vehicleid,
                connection: connection,
                install: install,
                accessorytype: accessorytype
            },
        }).done(function (response) {
            self.displayGuides(response)
        }).fail(function (xhr, textStatus, errorThrown) {
            console.log(textStatus)
        });
    }

    //ajax for request the complete list of guides for the product id 
    getAllGuides() {
        let self = this;
        let productid = document.querySelector(this.params.guideFinderProductIdTag).getAttribute(this.params.guideFinderProductIdSelector)
        $.ajax({
            url: self.urls.guides,
            method: "POST",
            data: { productid: productid },
        }).done(function (response) {
            self.displayGuides(response)
        }).fail(function (xhr, textStatus, errorThrown) {
            console.log(textStatus)
        });
    }

    //ajax for request the guide for the number in param
    getGuideByNumber() {
        let self = this
        let searchedValue = document.querySelector(this.params.guideFinderInputSearchSelector).value
        $.ajax({
            url: self.urls.guides,
            method: "POST",
            data: { guideid: searchedValue },
        }).done(function (response) {
            self.displayGuides(response)
        }).fail(function (xhr, textStatus, errorThrown) {
            console.log(textStatus)
        });
    }

    //show and hide guide in fact of list of guides received 
    displayGuides(guideToShow) {
        let ListOfGuides = document.querySelectorAll('a[' + this.params.guideFinderGuideIdSelector + ']')
        ListOfGuides.forEach(element => {
            element.classList.add('d-none')
            guideToShow.forEach(elementToShow => {
                let dataGuideId = element.getAttribute(this.params.guideFinderGuideIdSelector)
                if (elementToShow.guideid === dataGuideId) {
                    element.classList.remove('d-none')
                }
            })
        });
    }
}
